import { isLessonAvailabilityFlow } from 'common/infrastructure/modules/appointment/interfaces/AppointmentTypes';
import { add, endOfMonth, format, startOfToday } from 'date-fns';
import { useEffect, useMemo, useState } from 'react';

import { IGetLessonAvailabilityAdapter } from 'application/modules/bookingWizard/useCases/hooks/useCaseSelectLessonReservationDate';
import mboAPI from 'infrastructure/redux/adapters/mboAPI/mboApi';
import {
  selectExperienceType,
  selectLocation,
} from 'infrastructure/redux/slices/bookingWizard.selector';
import { useAppSelector } from 'infrastructure/redux/store/hooks';

const useGetLessonAvailability: IGetLessonAvailabilityAdapter = () => {
  const selectedLocationId = useAppSelector(selectLocation);
  const startDateTime = useMemo(() => format(startOfToday(), 'yyyy-MM-dd'), []);
  const [endDateTime, setEndDateTime] = useState(
    format(endOfMonth(add(new Date(), { months: 1 })), 'yyyy-MM-dd'),
  );
  const experienceType = useAppSelector(selectExperienceType);

  const [
    fetchAvailableLessonDates,
    { data: availableDatesMap, error, isLoading, isFetching },
  ] = mboAPI.useLazyGetAvailableLessonDatesQuery();

  useEffect(() => {
    if (
      selectedLocationId &&
      startDateTime &&
      endDateTime &&
      isLessonAvailabilityFlow(experienceType)
    ) {
      fetchAvailableLessonDates({
        locationId: selectedLocationId,
        startDateTime,
        endDateTime,
      });
    }
  }, [
    selectedLocationId,
    startDateTime,
    endDateTime,
    experienceType,
    fetchAvailableLessonDates,
  ]);
  const availableDates = useMemo(
    () => availableDatesMap?.map((date) => new Date(date)),
    [availableDatesMap],
  );

  const handleFetchFurtherAvailableDates = (newDate: Date | null) => {
    if (newDate) {
      setEndDateTime(format(endOfMonth(add(newDate, { months: 1 })), 'yyyy-MM-dd'));
    }
  };

  return {
    inProgress: isLoading || isFetching,
    error,
    result: availableDates,
    fetchFurtherAvailableDates: handleFetchFurtherAvailableDates,
  };
};

export default useGetLessonAvailability;
